import { useState } from "react";
import { useTranslation } from "react-i18next";

type PlatformKey = "windows" | "macos" | "linux";

export function SystemRequirements() {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(true);
  const [activeTab, setActiveTab] = useState<PlatformKey>("windows");

  const tabs: { id: PlatformKey; label: string }[] = [
    { id: "windows", label: t("downloads.platforms.windows.name") },
    { id: "macos", label: t("downloads.platforms.macos.name") },
    { id: "linux", label: t("downloads.platforms.linux.name") },
  ];

  return (
    <div className="bg-dark-card rounded-xl border border-dark-border overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-dark-hover transition-colors"
      >
        <h3 className="text-lg font-semibold text-warm-50">{t('downloads.systemRequirements.title')}</h3>
        <svg
          className={`w-5 h-5 text-warm-500 transition-transform ${isExpanded ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isExpanded && (
        <div className="border-t border-dark-border">
          <div className="flex border-b border-dark-border">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 text-sm font-medium transition-colors ${
                  activeTab === tab.id
                    ? "text-warm-50 border-b-2 border-blue-500"
                    : "text-warm-500 hover:text-warm-100"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="p-6 space-y-4">
            <RequirementRow label={t('downloads.systemRequirements.labels.os')} value={t(`downloads.systemRequirements.${activeTab}.os`)} />
            <RequirementRow label={t('downloads.systemRequirements.labels.memory')} value={t(`downloads.systemRequirements.${activeTab}.ram`)} />
            <RequirementRow label={t('downloads.systemRequirements.labels.disk')} value={t(`downloads.systemRequirements.${activeTab}.disk`)} />
            <RequirementRow label={t('downloads.systemRequirements.labels.notes')} value={t(`downloads.systemRequirements.${activeTab}.notes`)} />
          </div>
        </div>
      )}
    </div>
  );
}

function RequirementRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
      <span className="text-sm text-warm-500 sm:w-32 flex-shrink-0">{label}</span>
      <span className="text-sm text-warm-200">{value}</span>
    </div>
  );
}
